
import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class HeplDialog extends Vue {
  panel = false;

  closeDialog() {
    this.$store.dispatch(`help/closeModal`, {name: 'help'});
  }
}
